import React from 'react';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import { AiFillLock } from "react-icons/ai";
import './LockCircle.css';

interface LockCircleProps {
  lockedPercentage: number;
}

const LockIcon = AiFillLock as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

const LockCircle: React.FC<LockCircleProps> = ({ lockedPercentage }) => {
  const clampedValue = Math.max(0, Math.min(lockedPercentage, 100));
  const tooltipText = `Locked: ${clampedValue}%`;

  return (
    <div>
      <div 
        className="circle-container"
        data-tooltip-id="lock-tooltip"
        data-tooltip-content={tooltipText}
      >
        <div
          className="circle-progress"
          style={{ '--locked-value': clampedValue + '%' } as React.CSSProperties}
        />
        <LockIcon className="lock-icon" />
      </div>
      <Tooltip id="lock-tooltip" />
    </div>
  );
};

export default LockCircle;
